import { useState } from "react";
import { Phone, Mail, MessageCircle, X } from "lucide-react";

export default function ContactWidget() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-40" data-testid="contact-widget">
      {open && (
        <div className="mb-3 w-72 rounded-2xl bg-[#F8FAFC] border border-[#1E5F8C]/10 soft-shadow p-5 animate-in fade-in slide-in-from-bottom-2">
          <div className="flex items-start justify-between gap-2">
            <div>
              <p className="font-serif text-lg text-[#0F2942]">We’re here to help</p>
              <p className="text-sm text-[#475569] mt-1">Reach out any time, we respond fast.</p>
            </div>
            <button onClick={() => setOpen(false)} aria-label="Close" className="text-[#475569] hover:text-[#0F2942]">
              <X size={18} />
            </button>
          </div>
          <div className="mt-4 space-y-2">
            <a href="tel:+16478040263" className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-[#EEF4F8] text-sm text-[#0F2942]" data-testid="widget-call">
              <Phone size={16} className="text-[#1E5F8C]" /> Call 647-804-0263
            </a>
            <a href="mailto:info@julicarehealthservices.com" className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-[#EEF4F8] text-sm text-[#0F2942]" data-testid="widget-email">
              <Mail size={16} className="text-[#1E5F8C]" /> info@julicarehealthservices.com
            </a>
            <a href="#contact" onClick={() => setOpen(false)} className="block mt-2 text-center rounded-full bg-[#1E5F8C] text-[#F8FAFC] py-2.5 text-sm font-medium hover:bg-[#2A75AB]">
              Send a message
            </a>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Contact us"
        className="h-14 w-14 rounded-full bg-[#1E5F8C] text-[#F8FAFC] shadow-lg hover:bg-[#2A75AB] flex items-center justify-center"
        data-testid="contact-widget-toggle"
      >
        {open ? <X size={22} /> : <MessageCircle size={22} />}
      </button>
    </div>
  );
}
